<template>
	<section class="view-ui-callout-action">
		<div class="content">
			<h5 class="title">{{ title }}</h5>

			<p class="subtitle type-small-paragraph">
				{{ subtitle }}
			</p>
		</div>

		<div>
			<slot>
				<ChalkyButtonCamera v-on:click="Handle_OnClickAction" />
			</slot>
		</div>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, bind, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Callout
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiCalloutAction extends ViewBase {
		/**
		 * Subtitle of the callout
		 *
		 * @type string
		 */
		@Prop()
		public subtitle!: string;

		/**
		 * Title of the callout
		 *
		 * @type string
		 */
		@Prop()
		public title!: string;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @return Promise<void>
		 */
		@bind
		protected async Handle_OnClickAction(e: Event): Promise<void> {
			this.$emit('action');
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-ui-callout-action {
		align-items: center;
		display: flex;
		justify-content: space-between;
		padding: 2rem 0.5rem;

		.content {
			padding-right: 2rem;

			.subtitle {
				color: var(--chalky-grey);
			}
		}
	}
</style>
